export default {
  '台北': [
    // 台北市
    '信義威秀影城',
    'MUVIE CINEMAS松仁威秀',
    '美麗新宏匯影城',
    '誠品電影院',
    '喜樂時代影城南港店',
    '京站威秀影城',
    '新民生戲院',
    '微風國賓影城',
    '總督影城',
    '哈拉影城',
    '國賓大戲院',
    '樂聲影城',
    '日新威秀影城',
    'in89豪華數位影城',
    '台北新光影城',
    '今日秀泰影城',
    '真善美戲院',
    '喜滿客絕色影城',
    '梅花數位影院',
    '百老匯數位影城',
    '東南亞秀泰影城',
    '光點華山電影館',
    '長春國賓影城',
    '欣欣秀泰影城',
    '光點台北',
    '美麗華大直影城',
    '美麗新大直皇家影城',
    '華威天母影城',
    '陽明戲院',
    '湳山戲院',
    '景美佳佳戲院',
    '朝代大戲院',

    // 新北市
    '環球國賓影城',
    '喜樂時代影城永和店',
    '鴻金寶麻吉影城',
    '晶冠廣場國賓影城',
    '三重天台戲院',
    '昕境廣場國賓影城',
    '林口MITSUI OUTLET PARK威秀影城',
    '美麗新淡海影城',
    '淡水禮萊國賓影城',
    '板橋大遠百威秀影城',
    '板橋秀泰影城',
    '樹林秀泰影城',
    '土城秀泰影城',
    '板橋林園電影城',
  ],
  '桃園': [
    '桃園統領威秀影城',
    'in89豪華統領影城',
    '八德廣豐新天地國賓影城',
    '美麗新台茂影城',
    '桃園新光影城',
    'SBC星橋國際影城',
    '威尼斯影城',
    '中源戲院',
    '民和戲院',
  ],
  '新竹': [
    '新竹大遠百威秀影城',
    '新竹巨城威秀影城',
    '星際國際影城本館',
    '星際國際影城中興館',
    '新復珍戲院',
  ],
  '台中': [
    '台中新光影城',
    '台中大遠百威秀影城',
    '台中老虎城威秀',
    '台中文心秀泰影城',
    '華威台中影城',
    '台中站前秀泰影城',
    '凱擘影城',
    '日日新大戲院',
    '親親戲院',
    'in89豪華影城',
    '豐源國際影城',
    '時代數位3D影城',
    '台中麗寶秀泰影城',
    '萬代福影城',
    '全球影城',
  ],
  '台南': [
    '台南大遠百威秀影城',
    '台南南紡威秀影城',
    '台南Focus威秀影城',
    '台南新光影城',
    '台南國賓影城',
    '台南真善美劇院',
    '南台電影城',
    '仁德秀泰影城',
    '麻豆戲院',
    '全美戲院',
    '今日戲院',
  ],

  '高雄': [
    '高雄大遠百威秀影城',
    '喜滿客夢時代影城',
    '大魯閣草衙道國賓影城',
    '義大國賓影城',
    '大立in89豪華影城',
    'in89駁二電影院',
    'MLD台鋁影城',
    '環球數位3D影城',
    '美奇萊影城',
    '奧斯卡雷射數位影城',
    '岡山統一3D數位戲院',
    '十全數位3D影城',
  ]
}
